import { useMemo } from "react";

import { isNotNullOrEmpty } from "./TypingUtils";

export function uuid(): string {
    return uuidV4Pattern.replace(/[018]/g, randomHexDigit);
}

function randomHexDigit(placeholder: string): string {
    return (Number(placeholder) ^ ((Math.random() * 16) >> (Number(placeholder) / 4))).toString(16);
}

const uuidV4Pattern = "10000000-1000-4000-8000-100000000000";

const guidMatch = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const isValidGuid = (value: string): boolean => isNotNullOrEmpty(value) && guidMatch.test(value);

export const useUUID = () => useMemo(() => window.crypto.randomUUID(), []);
